module.exports = __webpack_public_path__ + "static/media/garage-main-page.3ff941cc.jpg";